import styled from "@emotion/styled";
import { Omit } from "utility-types";
import { IconProps } from "./IconProps";

type IconWrapperProps = Omit<
    IconProps,
    "svgComponent" | "dangerouslySetSvg" | "height" | "width"
> & {
    height: string;
    width: string;
};

export const IconWrapper = styled.span<IconWrapperProps>(
    ({ color, height, width, wrapperCss = {} }) => ({
        display: "inline-block",
        flexShrink: 0,
        lineHeight: 1,

        // We're intentionally add this spread here since we control the following props more carefully.
        ...(wrapperCss as Record<string, unknown>),

        color,
        height: `var(--lodestar-icon-height, var(--lodestar-icon-size, ${height}))`,
        width: `var(--lodestar-icon-width, var(--lodestar-icon-size, ${width}))`,
    }),
    ({ height, width, svgCss = {} }) => ({
        "> svg": {
            maxHeight: "100%",
            maxWidth: "100%",
            overflow: "hidden",
            pointerEvents: "none",
            verticalAlign: "bottom",

            // We're intentionally add this spread here since we control the following props more carefully.
            ...(svgCss as Record<string, unknown>),

            height: `var(--lodestar-icon-height, var(--lodestar-icon-size, ${height}))`,
            width: `var(--lodestar-icon-width, var(--lodestar-icon-size, ${width}))`,
        },
    })
);

IconWrapper.displayName = "IconWrapper";
